module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.1f35e6a.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Thin.woff2
// module id = 457
// module chunks = 1